<template>

  <!-- <el-menu-item :index="menu.path || uniqueId"  v-if="auths.includes(menu.auth_token)||menu.auth_token=='header'"> -->
  <el-menu-item :index="this.getMatchStatus.matchId||menu.path.includes('/member' )? (menu.path||uniqueId) : uniqueId" @click="goto(menu.path)">
    <!-- <i v-if="menu.icon" :class="`fa fa-${menu.icon}`"></i> -->
    <i v-if="menu.icon" :class="`iconfont ${menu.icon}`"></i>
    <!-- <i v-if="menu.icon === undefined & !menu.iconSvg" class="fa fa-file-o"></i> -->
    <d2-icon-svg v-if="menu.iconSvg" :name="menu.iconSvg"/>
    <span slot="title">{{menu.title || '未命名菜单'}} </span>
  </el-menu-item>
</template>

<script>
import { uniqueId } from 'lodash'
import { mapState,mapGetters } from 'vuex'
export default {
  name: 'd2-layout-header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...mapState('d2admin/menu', [
      'aside',
      'asideCollapse',
      'auths'
    ]),
    ...mapGetters('d2admin/user', [
      'getMatchStatus'
    ]),
  },
  data () {
    return {
      uniqueId: uniqueId('d2-menu-empty-')
    }
  },
  methods:{
    goto(path){
      console.log(path,'path')
      console.log(!this.getMatchStatus.matchId&&path!='/member','haha')
      if(!this.getMatchStatus.matchId&&!path.includes('/member')){
        console.log('this.getMatchStatus.matchId',this.getMatchStatus.matchId)
        this.$message.warning('请先创建赛事')
        return
      }
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/components/menu-item/index.vue"
}
</vue-filename-injector>
